// extracted by mini-css-extract-plugin
module.exports = {"coupon-code-wrapper":"_1WVRS"};